import httpClient from "@/api/httpClient";
import PropertyAvailability from "@/model/PropertyAvailability";
import PropertyImageUploadResponse from "@/model/PropertyImageUploadResponse";
import PropertyPage from "@/model/PropertyPage";
import PropertyRequest from "@/model/PropertyRequest";
import PropertyResponse from "@/model/PropertyResponse";

function listPropertiesForCompany(
  accessToken: string,
  companyId: string,
  page: number,
  size: number
): Promise<PropertyPage> {
  return httpClient.getJson<PropertyPage>(
    `/api/companies/${encodeURIComponent(companyId)}/properties?page=${page}&size=${size}`,
    accessToken
  );
}

function listAllProperties(
  accessToken: string,
  page: number,
  size: number
): Promise<PropertyPage> {
  return httpClient.getJson<PropertyPage>(
    `/api/properties?includeUnlisted=true&page=${page}&size=${size}`,
    accessToken
  );
}

function getPropertyById(
  accessToken: string,
  id: string
): Promise<PropertyResponse> {
  return httpClient.getJson<PropertyResponse>(
    `/api/properties/${id}`,
    accessToken
  );
}

function getAvailability(id: string): Promise<PropertyAvailability> {
  return httpClient.getJson<PropertyAvailability>(
    `/api/properties/${id}/availability`
  );
}

function createProperty(
  accessToken: string,
  request: PropertyRequest
): Promise<PropertyResponse> {
  return httpClient.postJson<PropertyResponse>(
    "/api/properties",
    request,
    accessToken
  );
}

function updateProperty(
  accessToken: string,
  id: string,
  request: PropertyRequest
): Promise<PropertyResponse> {
  return httpClient.putJsonBody<PropertyResponse>(
    `/api/properties/${id}`,
    request,
    accessToken
  );
}

function deleteProperty(accessToken: string, id: string): Promise<void> {
  return httpClient.deleteNoContent(`/api/properties/${id}`, accessToken);
}

function createImageUpload(
  accessToken: string,
  id: string
): Promise<PropertyImageUploadResponse> {
  return httpClient.postJson<PropertyImageUploadResponse>(
    `/api/properties/${id}/images`,
    {},
    accessToken
  );
}

async function uploadImage(uploadUrl: string, file: File): Promise<void> {
  const response = await fetch(uploadUrl, {
    method: "PUT",
    headers: {
      "Content-Type": file.type,
    },
    body: file,
  });

  if (!response.ok) {
    throw new Error(`Image upload failed with status ${response.status}`);
  }
}

const propertiesApi = {
  listPropertiesForCompany,
  listAllProperties,
  getPropertyById,
  getAvailability,
  createProperty,
  updateProperty,
  deleteProperty,
  createImageUpload,
  uploadImage,
};

export default propertiesApi;
